import { StrictMode } from "react";
import { createReactRoot } from "common/react/create-react-root";
import { App } from "@design-lab/app";

function init() {
  let container = document.querySelector(".js-design-lab");

  if (!container) {
    container = document.createElement("div");
    document.body.appendChild(container);
  }

  // Read config from data attribute
  const configData = container.getAttribute("data-config");
  const config = configData ? JSON.parse(configData) : {};

  createReactRoot(container, "Design Lab").render(
    <StrictMode>
      <App config={config} />
    </StrictMode>
  );
}

document.addEventListener("DOMContentLoaded", () => {
  init();
});
